import { mergeAttributes, Node } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import FreeHtmlElementNode from './FreeHtmlElementNode.vue'

export const FreeHtmlElement = Node.create({
  name: 'freeHtmlElement',
  group: 'block',
  atom: true,

  addAttributes() {
    return {
      html: {
        default: '',
      },
      fh_id: {
        default: 0
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-free-html-element]',
        getAttrs: (element) => ({
          html: element.innerHTML,
          fh_id: element.getAttribute('data-fh-id') || ''
        }),
      },
    ]
  },

  renderHTML({ node }) {
    const wrapper = document.createElement('div');
    wrapper.setAttribute('data-free-html-element', 'true');
    wrapper.setAttribute('data-fh-id', node.attrs.fh_id);
    wrapper.innerHTML = node.attrs.html;

    return {
      dom: wrapper,
      contentDOM: null 
    };
  },

  addNodeView() {
    return VueNodeViewRenderer(FreeHtmlElementNode)
  },
})
